import auth from '@/router/auth'
import CategoryItemIndex from '@/components/activity-logs/Index'

export default [
  {
    path: '/activity-logs',
    name: 'activity-logs-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/activity-logs/router.js